import { IconProps } from '@euler/app/components/icons/types';
import { useSvgProps } from '@euler/app/components/icons/util';
import { FC, memo } from 'react';
import { Path, Svg } from 'react-native-svg';

export const VideosIcon: FC<IconProps> = memo(props => {
  const { fill = '#000', ...svgProps } = useSvgProps(props, 50, 50);
  return (
    <Svg viewBox="0 0 1024 1024" fill="none" {...svgProps}>
      <Path
        d="M867.543579 768h-91.621053V700.631579h91.621053a13.204211 13.204211 0 0 0 12.288-13.904842v-452.176842a13.204211 13.204211 0 0 0-12.288-13.904842H338.890105a13.204211 13.204211 0 0 0-12.288 13.904842v92.752842H259.395368V234.549895A80.842105 80.842105 0 0 1 338.890105 153.276632h528.49179a80.842105 80.842105 0 0 1 79.656421 81.273263v452.176842a80.842105 80.842105 0 0 1-79.494737 81.273263z"
        fill={fill}
      />
      <Path
        d="M121.263158 281.168842h590.955789a98.465684 98.465684 0 0 1 98.357895 98.357895v484.298105a98.465684 98.465684 0 0 1-98.357895 98.357895H121.263158a98.465684 98.465684 0 0 1-98.357895-98.357895V379.526737A98.465684 98.465684 0 0 1 121.263158 281.168842z m590.955789 613.645474a31.043368 31.043368 0 0 0 30.989474-30.989474V379.526737a31.043368 31.043368 0 0 0-30.989474-30.989474H121.263158a31.043368 31.043368 0 0 0-30.989474 30.989474v484.298105a31.043368 31.043368 0 0 0 30.989474 30.989474z"
        fill={fill}
      />
      <Path
        d="M652.395789 557.810526a42.630737 42.630737 0 1 1-42.630736-42.630737 42.630737 42.630737 0 0 1 42.630736 42.630737"
        fill={fill}
      />
      <Path
        d="M272.276211 676.702316v-107.789474A29.749895 29.749895 0 0 1 317.978947 543.797895l82.189474 52.11621 88.225684 55.834948a29.803789 29.803789 0 0 1 0 50.283789l-88.225684 55.834947-82.189474 52.116211a29.749895 29.749895 0 0 1-45.702736-25.114947z"
        fill={fill}
      />
      <Path
        d="M776.946526 455.248842H56.643368v-67.368421h720.303158z"
        fill={fill}
      />
    </Svg>
  );
});
